/*
 *
 * NewTreatmentResultStep actions
 *
 */

import { DEFAULT_ACTION, PLAN_ACTIVITY } from "./constants";

export function planActivityAction(planning, timeSlotId) {
  return {
    type: PLAN_ACTIVITY,
    planning,
    timeSlotId,
  };
}

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}
